module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage ssTab4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过姓名，身份证号（军官证号），手机号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa1df99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssBlock/forTabs/ssTab4.vue
// module id = 1713
// module chunks = 1